import 'react';
import Grid from '@lendi-ui/grid';
import parse, { domToReact } from 'html-react-parser';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Container from '@lendi-ui/container';
import { mt, mb, m } from '@lendi-ui/spacing';
import styled from 'styled-components';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { handleLinkTrackingEvent } from '@lendi-jam/tracking';
import { Heading, Body, Link } from '@lendi-ui/typography';
import { jsx } from 'react/jsx-runtime';

var _templateObject;
var GenericRichTextContainer = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: ", ";\n  ", "\n  ", "\n  ul,\n  ol {\n    font-family: 'Open Sans', sans-serif;\n    ", "\n    ", "\n\n    li {\n      ", "\n      p {\n        ", "\n      }\n    }\n  }\n\n  ", " > *:first-child {\n    margin-top: 0;\n  }\n"])), function (props) {
  return props.textAlign || 'initial';
}, mt('lg'), mb('lg'), m('nil'), mt('sm'), mt('xs'), mt('xs'), Grid.Unit);

var getReactChildren = function getReactChildren(node, options) {
  if (node.children) {
    return domToReact(node.children, options);
  } else {
    return node.data;
  }
};
var HEADING_SIZE = /*#__PURE__*/function (HEADING_SIZE) {
  HEADING_SIZE["h1"] = "xl";
  HEADING_SIZE["h2"] = "lg";
  HEADING_SIZE["h3"] = "sm";
  HEADING_SIZE["h4"] = "xs";
  HEADING_SIZE["h5"] = "xs";
  HEADING_SIZE["h6"] = "xs";
  return HEADING_SIZE;
}(HEADING_SIZE || {});
var replaceElement = function replaceElement(domNode) {
  var linkColour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'secondary.500';
  var bodySize = arguments.length > 2 ? arguments[2] : undefined;
  var options = {
    replace: replaceElement
  };
  var name = domNode.name,
    attribs = domNode.attribs;
  switch (name) {
    case 'p':
      {
        return /*#__PURE__*/jsx(Body, {
          mt: "sm",
          size: bodySize ? bodySize : 'md',
          children: getReactChildren(domNode, options)
        });
      }
    case 'em':
      return /*#__PURE__*/jsx("em", {
        children: getReactChildren(domNode, options)
      });
    case 'strong':
      return /*#__PURE__*/jsx("strong", {
        children: getReactChildren(domNode, options)
      });
    case 'a':
      return /*#__PURE__*/jsx(Link, _objectSpread(_objectSpread({
        color: linkColour
      }, attribs), {}, {
        onClick: function onClick() {
          handleLinkTrackingEvent(domNode.attribs.href);
        },
        children: getReactChildren(domNode, options)
      }));
    case 'li':
      return /*#__PURE__*/jsx("li", {
        children: /*#__PURE__*/jsx(Body, {
          mt: "sm",
          size: bodySize ? bodySize : 'md',
          children: getReactChildren(domNode, options)
        })
      });
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return /*#__PURE__*/jsx(Heading, {
        mt: "lg",
        size: HEADING_SIZE[name],
        as: name,
        children: getReactChildren(domNode, options)
      });
    default:
      {
        return domNode;
      }
  }
};

var options = {
  replace: replaceElement
};
var GenericRichText = function GenericRichText(_ref) {
  var content = _ref.content,
    textAlign = _ref.textAlign,
    isFullWidth = _ref.isFullWidth;
  return /*#__PURE__*/jsx(GenericRichTextContainer, {
    textAlign: textAlign,
    children: /*#__PURE__*/jsx(Grid, {
      halign: "center",
      children: /*#__PURE__*/jsx(Grid.Unit, {
        size: isFullWidth ? 1 : {
          xs: 1,
          lg: 8 / 10,
          xl: 10 / 12
        },
        children: parse(content, options)
      })
    })
  });
};

export { GenericRichText as default, replaceElement };
